import { render, staticRenderFns } from "./DefaultHeaderDropdownAccnt.vue?vue&type=template&id=484ce9a9&"
import script from "./DefaultHeaderDropdownAccnt.vue?vue&type=script&lang=ts&"
export * from "./DefaultHeaderDropdownAccnt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports